import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';

import { cn } from 'src/lib/utils';

const labelVariants = cva(
  'font-medium text-layout-foreground text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
);

const Label = ({
  className,
  ref,
  ...props
}: (ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants>) & {
  ref?: Ref<ComponentRef<typeof LabelPrimitive.Root>>;
}) => (
  <LabelPrimitive.Root
    className={cn(labelVariants(), className)}
    ref={ref}
    {...props}
  />
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
